import { styled } from "@mui/material";
import { MaterialDesignContent, SnackbarProvider } from "notistack";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import { useEffect } from "react";
import MainLayout from "./components/layout";
import Snackbar from "./components/snackbar";
import { constants } from "./constants/variables";
import { ADMIN_ROUTES, AUTH_ROUTES, GENERAL_ROUTES } from "./routes";
import "./styles/global.css";
import { AuthProtectedLayout, ProtectedLayout } from "./routes/RoutesLayout";
import useAdminSettings from "./zustand/useAdminSettingsStore";
import DeletationForm from "./app/deletationForm";
import PrivacyPolicy from "./app/privacyPolicy";

const StyledMaterialDesignContent = styled(MaterialDesignContent)(() => ({
  "&.notistack-MuiContent-success": {
    backgroundColor: "#225B27",
  },
  "&.notistack-MuiContent-error": {
    backgroundColor: "#FF0000",
  },
}));

function App() {
  const { fetchSettings } = useAdminSettings();

  // Auto-fetch settings on app load
  useEffect(() => {
    fetchSettings();
  }, [fetchSettings]);

  return (
    <SnackbarProvider
      maxSnack={4}
      autoHideDuration={4000}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      Components={{
        success: StyledMaterialDesignContent,
        error: StyledMaterialDesignContent,
      }}
    >
      <Router>
        <Routes>
          <Route path="/deletion-form" element={<DeletationForm />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route element={<AuthProtectedLayout />}>
            {AUTH_ROUTES?.map((route) => (
              <Route
                key={route.id}
                path={route.path}
                element={route.component}
              />
            ))}
          </Route>

          <Route element={<ProtectedLayout />}>
            {ADMIN_ROUTES?.map((route) => (
              <Route
                key={route.id}
                path={route.path}
                element={<MainLayout>{route.component}</MainLayout>}
              />
            ))}
          </Route>

          <Route>
            {GENERAL_ROUTES?.map((route) => (
              <Route
                key={route.id}
                path={route.path}
                element={<MainLayout>{route.component}</MainLayout>}
              />
            ))}
          </Route>
        </Routes>
      </Router>
      <Snackbar
        ref={(ref) => {
          constants.snackAlert = ref;
        }}
      />
    </SnackbarProvider>
  );
}

export default App;
